import React from 'react';
import './Team.css';

const Team = () => {
  const teamMembers = [
    {name: 'DRILLA', role: 'BEAR BOSS', position: 'Founder', image: 'drilla.jpg', twitter: 'https://twitter.com/drillatrades'},
    {name: 'POOH', role: 'BEAR BOSS', position: 'Founder', image: 'pooh.png', twitter: 'https://twitter.com/poohbtc'},
    {name: 'Jaeyy', role: 'BEAR CREW', position: 'Head Mod', image: 'jaeyyy.jpg', twitter: 'https://twitter.com/0xJaey'},
    {name: 'Hayat', role: 'BEAR HELPER', position: 'Moderator', image: 'hayat.png', twitter: 'https://twitter.com/'},
    {name: 'Petrec', role: 'BEAR HELPER', position: 'Community', image: 'petrec.png', twitter: 'https://twitter.com/PetrecM'},
    {name: 'Pranayyy', role: 'BEAR HELPER', position: 'Community', image: 'pranayyy.jpg', twitter: 'https://twitter.com/Pranayyy_eth'},
    {name: 'NFTDADE23', role: 'BEAR HELPER', position: 'Community', image: 'nftdade.jpg', twitter: 'https://twitter.com/NFTDADE23'},
    {name: 'WarriorMama', role: 'BEAR HELPER', position: 'Community', image: 'warriormama.jpg', twitter: 'https://twitter.com/WarriorMama5'},
  ];

  return (
    <div className="team-section">
      <h2 className='team-title'>BITCOIN BEARS CREW</h2>
      <p className='team-description'>
As pioneers within the Bitcoin ordinals, the Bitcoin Bears represents a groundbreaking art project. We are the early creators, driven by a shared vision to redefine the boundaries of artistic expression. With a diverse range of talents, we unite our expertise to construct an immersive experience that challenges the status quo. Join us as we embark on an extraordinary journey towards a new era in the world of art and creativity.</p>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="team-member">
            <img src={member.image} alt={member.name} className="team-member-image" />
            <div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <p className="member-position">{member.position}</p>
            </div>
            <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="svg-link">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7224 8.65878 27.7095 8.62731 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z" fill="#47ACDF"></path> </g></svg>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
